import "./ForgetPass2.css";
import EmailSent from "../../assets/gif/emailsent.gif";
import FallbackImg from "../../components/FallbackImg";

const ForgetPass2 = () => {
  return (
    <div className="forgetpass2">
      <div className="forgetpass2-content">
        <div className="forgetpass2-main">
          <div className="forgetpass2-gif">
            <FallbackImg src={EmailSent} alt="emailsent" width="180px" height="180px" />
          </div>
          <div className="forgetpass2-text">
            We had sent a reset password link to the email address, please
            continue from there / contact your admin
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPass2;
